export const COMPANY_NAME = "Snapshot Live Limited";

export const COMPANY_ADDRESS_LINES = [
  "DOCK 2/006",
  "85 Explorations Drive",
  "LE4 5NU, Leicester, United Kingdom",
] as const;

export const COMPANY_REGISTRATION_NUMBER = "16174031";

export const COMPANY_REGISTERED_OFFICE = `${COMPANY_NAME}, ${COMPANY_ADDRESS_LINES.join(", ")}`;

export const COMPANY_PDF_FOOTER = `Company Registration No: ${COMPANY_REGISTRATION_NUMBER}. Registered Office: ${COMPANY_REGISTERED_OFFICE}.`;